import { setPusherClient } from 'react-pusher';
import Pusher from 'pusher-js';
const pusherClient = new Pusher(process.env.REACT_APP_PUSHER_APP_KEY, {
    cluster: 'eu'
});

setPusherClient(pusherClient);